import AddIcon from '../../../../ui/components/icons/add-icon';
import { Button } from '../../../../ui/components/ui/button';
import { ArchiveFilter } from '../../constants/archive-filter.enum';
import ArchiveFilterButtons from '../archive-filter-buttons/archive-filter-buttons';

export interface ListToolbarProps {
  filter: ArchiveFilter;
  onFilterChange: (filter: ArchiveFilter) => void;
  createLabel: string;
  onCreate: () => void;
}

const ListToolbar = ({ filter, onFilterChange, createLabel, onCreate }: ListToolbarProps) => (
  <div className="flex justify-between items-center gap-3">
    <ArchiveFilterButtons value={filter} onChange={onFilterChange} />
    <Button className="flex gap-3" onClick={onCreate}>
      <AddIcon />
      <span>{createLabel}</span>
    </Button>
  </div>
);

export default ListToolbar;
